import { get } from './httpClient'

export const getInvitations = (params) => get('/invitation', params && params)